/**
 * progressKeys is a list of unique keys of actions that are currently in progress (different from loading)
 */
export interface State {
    progressKeys: string[];
}

export const initialState: State = {
    progressKeys: []
};
